/**
 * Formatea una fecha al formato: día mes año
 * Ejemplo: "23 nov 2024"
 * @param {string} fecha - Fecha en formato YYYY-MM-DD o ISO
 * @returns {string} Fecha formateada
 */
export const formatearFecha = (fecha) => {
  if (!fecha) return '';
  
  try {
    // Si la fecha está en formato YYYY-MM-DD, parsearla manualmente
    // para evitar problemas de zona horaria
    if (typeof fecha === 'string' && fecha.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const [año, mes, dia] = fecha.split('-').map(Number);
      const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
      return `${dia} ${meses[mes - 1]} ${año}`;
    }
    
    // Para otros formatos, usar Date (con cuidado de UTC)
    const date = new Date(fecha + 'T00:00:00'); // Forzar medianoche local
    
    // Verificar si la fecha es válida
    if (isNaN(date.getTime())) return fecha;
    
    const dia = date.getDate();
    const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    const mes = meses[date.getMonth()];
    const año = date.getFullYear();
    
    return `${dia} ${mes} ${año}`;
  } catch (error) {
    return fecha;
  }
};

/**
 * Formatea una fecha y hora al formato: día mes año, HH:MM
 * Ejemplo: "23 nov 2024, 14:30"
 * @param {string} fechaHora - Fecha en formato ISO
 * @returns {string} Fecha y hora formateada
 */
export const formatearFechaHora = (fechaHora) => {
  if (!fechaHora) return '';
  
  try {
    const date = new Date(fechaHora);
    
    if (isNaN(date.getTime())) return fechaHora;
    
    // Formatear la fecha
    const dia = date.getDate();
    const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    const mes = meses[date.getMonth()];
    const año = date.getFullYear();
    
    // Formatear la hora
    const horas = date.getHours().toString().padStart(2, '0');
    const minutos = date.getMinutes().toString().padStart(2, '0');
    
    return `${dia} ${mes} ${año}, ${horas}:${minutos}`;
  } catch (error) {
    return fechaHora;
  }
};
